import styles from './Second.module.scss';
import stickers from '../../../resources/stickers.png';
import cn from "classnames";

export const Second = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.bg}>
                <img src={stickers} alt="Стикеры 2x2"/>
            </div>
            <div className={styles.content}>
                <div className={styles.title}>Гифт от 2х2</div>
                <div className={styles.desc}>Вы залутали стикеры с героями «Колдуй отсюда»! Они дают постоянный БАФ в общении в Телеге</div>
                <a href="https://t.me/addstickers/Koldyi_2x2" id="stickers" className={cn("button", styles.button)} target="_blank" rel="nofollow noreferrer">Скачать</a>
            </div>
        </div>
    )
}